import React, { FC } from 'react';
import { observer } from 'mobx-react';
// modules
import { useStore } from 'modules/Stores';
// components
import { View } from '@upstox/upstox-ui';
import PriceAlert from './Components/PriceAlert';
// styles
import * as css from './styles';

const PriceAlertsNotification: FC = () => {
  const { triggeredAlerts } = useStore('PriceAlertsStore');
  if (triggeredAlerts.length === 0) return null;
  return (
    <View
      padding="medium"
      css={css.notificationContainer}
    >
      {triggeredAlerts.map((alert) => (
        <PriceAlert key={alert.id} alert={alert} />
      ))}
    </View>
  );
};

export default observer(PriceAlertsNotification);
